export const ModifyShotMadeToMissed = {
  name: "modify-shot-made-to-missed",
  component: "MainPanel",
  layout: "main-panel large align-center",
  mode: "visible",
  text: "edit.shot.success",
  showOn: [{ state: "editState", value: "shot-success-made", operator: "is" }],
  allowFlag: true,
  allowCancel: true,
  showDetails: { events: ["edit"] },
  children: [
    {
      name: "shot-made-to-missed-description",
      component: "PanelText",
      layout: "panel-text",
      mode: "visible",
      showOn: [
        {
          state: "event.subType",
          value: "shot",
          operator: "not",
          event: "main",
        },
      ],
      options: {
        layout: "description-text",
        text: "edit.shot.made.description.handball",
      },
      actionGroups: [],
    },
    {
      name: "shot-made-to-missed-change",
      component: "ButtonGroup",
      layout: "button-group true-false",
      mode: "visible",
      showOn: [true],
      startPlay: false,
      options: {
        value: "success",
        children: [false],
        layout: "type-button",
        prefix: "edit.shot.made.success",
      },
      actionGroups: [
        {
          actions: [
            { action: "clearData", value: [{ option: "attackType" }], type: "main" },
            { action: "sendEvent", value: "edit", type: "main" },
            { action: "deleteFromPlay", value: "assist", type: "main" },
            {
              action: "adjustTeamValue",
              value: -1,
              options: { currentEntity: true, item: "score" },
            },
            { action: "nextState", value: null, type: "editState" },
          ],
          conditions: [],
        },
      ],
    },
  ],
};
